//////// GHG 3.2 EA
const threeTwoSchema = {
  title: "3.2 Capital Goods",
  addAPI: "cat4_2AddEmissionActivityAPI",
  cat: "cat4_2",
  EATitle: "Emission Activity",
  fields: [
    {
      key: "goodsName",
      level: 1,
      type: "input",
      label: "Capital Goods Name / Type",
      resetOnChange: false,
      required: true,
    },
    {
      key: "activityId",
      level: 1,
      type: "select",
      label: "Raw Material type",
      optionsAPI:
        "capitalGoodsThatArePurchasedAndAmortizedByAnOrganizationProductTypeAPI",
      required: false,
    },
    {
      key: "itemName",
      level: 1,
      type: "input",
      label: "Supplier Name",
      resetOnChange: false,
      required: false,
    },
  ],
};

export default threeTwoSchema;
